import React from 'react';
import { Box, Text, Code } from '@razorpay/blade/components';
import { PlaceholderGroupProps } from './types';

const PlaceholderGroup = ({ title, placeholders }: PlaceholderGroupProps) => (
  <Box marginBottom="spacing.4">
    <Text size="small" weight="semibold" color="surface.text.gray.muted" marginBottom="spacing.2">
      {title}
    </Text>
    <Box display="flex" flexDirection="column" gap="spacing.2">
      {placeholders.map((item) => (
        <Box key={item.placeholder} display="flex" flexDirection="column" gap="spacing.1">
          <Code size="small">{item.placeholder}</Code>
          <Text size="xsmall" color="surface.text.gray.muted">
            {item.description}
          </Text>
        </Box>
      ))}
    </Box>
  </Box>
);

export { PlaceholderGroup };
